import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import customizableQuery from '~/graphql/customizable.gql';

function fetchCustomizable(_x, _x2) {
  return _fetchCustomizable.apply(this, arguments);
} // eslint-disable-next-line


function _fetchCustomizable() {
  _fetchCustomizable = _asyncToGenerator(function* (context, code) {
    const locale = context.state.i18n.currentLocale.iso;
    const {
      data
    } = yield context.app.apolloProvider.defaultClient.query({
      query: customizableQuery,
      variables: {
        locale,
        code
      }
    });
    return data.customizable;
  });
  return _fetchCustomizable.apply(this, arguments);
}

export { fetchCustomizable };